import { Schema } from './HalfHero.schema';
import { HalfHeroContent } from './HalfHeroContent';
import { HalfHeroMedia } from './HalfHeroMedia';

export function HalfHero({ cms }) {
  const { section, content, media } = cms;
  const {
    aspectDesktop,
    aspectMobile,
    aspectTablet,
    fill,
    mediaOrderDesktop,
    mediaOrderMobile,
  } = {
    ...media,
  };

  const maxWidthContainerClass = section?.fullWidth
    ? 'max-w-none'
    : 'max-w-[var(--content-max-width)]';
  const fillClass = fill
    ? 'h-full'
    : `md:before:float-left ${aspectTablet} ${aspectDesktop}`;
  const mediaOrderClasses = `${
    mediaOrderMobile === '2' ? 'order-2' : 'order-1'
  } ${mediaOrderDesktop === '2' ? 'md:order-2' : 'md:order-1'}`;
  const contentOrderClasses = `${
    mediaOrderMobile === '2' ? 'order-1' : 'order-2'
  } ${mediaOrderDesktop === '2' ? 'md:order-1' : 'md:order-2'}`;
  const mediaBgColorClass =
    section?.bgColor === 'var(--background)' ||
    section?.bgColor === 'var(--white)'
      ? 'bg-offWhite'
      : '';

  return (
    <div
      className={`${
        section?.fullBleed ? '' : 'px-contained'
      } relative overflow-hidden bg-[#f2f7fb] ${
        section?.verticalPadding ? 'py-contained' : ''
      }`}
      style={{ backgroundColor: section?.bgColor }}
    >
      <div
        className="absolute h-full w-full"
        style={{
          background:
            'linear-gradient(180deg, #2179C2 0%, #8DCEF9 51.04%, #F1DCC1 100%)',
          opacity: 0.15,
          transform: 'matrix(1, 0, 0, -1, 0, 0)',
        }}
      />
      <div
        className={`relative mx-auto grid grid-cols-1 items-center md:grid-cols-2 ${maxWidthContainerClass}`}
      >
        <div
          className={`relative w-full max-md:before:float-left ${aspectMobile} ${fillClass} ${mediaOrderClasses} ${mediaBgColorClass} ${
            content.alignmentMobileOverImage
              ? '!absolute z-[1] lg:!relative'
              : ''
          }`}
        >
          <HalfHeroMedia
            aboveTheFold={section?.aboveTheFold}
            media={media}
            videoAlt={content?.heading}
          />
        </div>

        <div
          className={`relative z-[2] flex w-full items-center md:before:float-left ${aspectTablet} ${aspectDesktop} ${contentOrderClasses}`}
        >
          <HalfHeroContent
            aboveTheFold={section?.aboveTheFold}
            content={content}
          />
        </div>
      </div>
    </div>
  );
}

HalfHero.displayName = 'HalfHero';
HalfHero.Schema = Schema;
